export default __webpack_public_path__ + "static/media/prod-img-7.ce6568a7.webp";